import toast from 'react-hot-toast';

import CheckSVG from '@/assets/icons/check.svg';
import CompleteSVG from '@/assets/icons/complete.svg';
import StarSVG from '@/assets/icons/star.svg';
import StarSolidSVG from '@/assets/icons/star-solid.svg';
import TrashSVG from '@/assets/icons/trash.svg';
import { PlusIcon } from '@/components/common/plus-icon';
import { SpinningIcon } from '@/components/common/spinning-icon';
import { State } from '@/features/single-measurement/types/state';

import { useFermentationAction } from '../../hooks/use-fermentation-action';
import { useFermentationUpdate } from '../../hooks/use-fermentation-update';
import { IFermentation } from '../../types/fermentation';
import { FermentationActionButton } from './action-button';

export const ActionButtonWrapper: React.FC<IFermentation> = ({
  id,
  state,
  batchCount,
  ...rest
}) => {
  const { openRemoveModal, openCompleteModal, openAddBatchModal } =
    useFermentationAction();

  const { setFavoriteMutation } = useFermentationUpdate({
    onErrorFn: () => toast.error('Something went wrong!'),
  });
  const favIcon = rest.is_favourite ? StarSolidSVG : StarSVG;
  const favAltText = rest.is_favourite ? 'unfavourite' : 'favourite';

  const handleFavoriteToggle = () => {
    setFavoriteMutation.mutate({ id, isFavourite: !rest.is_favourite });
  };

  // show/hide buttons base on the state
  const isRemoveEnabled = state === State.FermentationOngoing && batchCount === 0;
  const isCompleteEnabled = state === State.FermentationOngoing && batchCount >= 1;
  const isAddEnabled = state === State.FermentationOngoing;
  const isCompleted = [
    State.FermentationComplete,
    State.UserFermentationCompleted,
  ].includes(state);

  return (
    <div className="flex items-center justify-end w-full gap-4">
      {isRemoveEnabled ? (
        <FermentationActionButton onClick={() => openRemoveModal(id)}>
          <img src={TrashSVG} alt="delete" />
        </FermentationActionButton>
      ) : null}

      {isCompleteEnabled ? (
        <FermentationActionButton onClick={() => openCompleteModal(id)}>
          <img src={CheckSVG} alt="complete" />
        </FermentationActionButton>
      ) : null}

      {isAddEnabled ? (
        <FermentationActionButton onClick={() => openAddBatchModal(id)}>
          <PlusIcon color="black" />
        </FermentationActionButton>
      ) : null}

      {isCompleted ? (
        <FermentationActionButton onClick={handleFavoriteToggle}>
          {setFavoriteMutation.isLoading ? (
            <SpinningIcon />
          ) : (
            <img src={favIcon} alt={favAltText} />
          )}
        </FermentationActionButton>
      ) : null}

      {isCompleted ? (
        <div className="p-3">
          <img src={CompleteSVG} alt="complete" />
        </div>
      ) : null}
    </div>
  );
};
